import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import Login from './views/Login.vue'
import Index from './components/index.vue'

Vue.use(Router)

export default new Router({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'index',
      component: Home,
      meta:{
        title:'行业管理端-汽修企业概况',
        type:'login'
      }
    },
    {
      path: '/login',
      name: 'login',
      component: Login,
      meta: {
        title: '行业管理端-登陆页面',
        type: '' // 不需要鉴权
      }
    }
  ]
})
